export const EXTERNAL_VENDOR_ICON_GAP = 4

export const getExternalVendorIconsWidth = ({ count, size }: { count: number; size: number }) =>
  count === 0 ? 0 : count * size + (count - 1) * EXTERNAL_VENDOR_ICON_GAP
